;
define("notifications_profile.tpl", function(){});

